<template>
  <div class="not-found-container">
    <h3>{{ $t('record_not_found') }}</h3>
    <div>
      <router-link to="/"> {{ $t('go-back') }} </router-link>
    </div>
  </div>
</template>
<script>
export default {
  created() {
    console.log('RecordNotFound loaded')
    debugger
  },
}
</script>
<style lang="scss" scoped>
.not-found-container {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 100vh;
  background: var(--color-21);
  flex-direction: column;
}
a {
  color: var(--color-23) !important;
  background-color: transparent !important;
}
</style>
